import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
};

export default function liq1(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@liq1/SAVE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@liq1/SAVE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@liq1/SAVE_FAILURE': {
        draft.loading = false;
        break;
      }
      case '@liq1/UPDATE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@liq1/UPDATE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@liq1/UPDATE_FAILURE': {
        draft.loading = false;
        break;
      }
      default:
    }
  });
}